import * as React from "react";
import * as ReactDOM from "react-dom";
import l10n from "../../util/l10n";
import Overlay from "./Overlay";
import { OverlayStatus } from "../index";
import Modul from '../../module/Modul';
import AppRegistry from '../../AppRegistry';
import SyncPosition, {PositionBox} from "../../components/SyncPosition";
import Spotlight from "./Spotlight";
import {OpacityAnimation} from "./Animation";
import {MODULE_ACTION_BAR_ELEMENT_ID} from "../../module-action-bar/components/ModuleActionBar";
import jquery = require("jquery");

import {toggleElementsMenu} from 'diy/module/section/index';

import ModeEditIcon from 'material-ui/svg-icons/editor/mode-edit';
import KeyboardArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import ContentCopyIcon from 'material-ui/svg-icons/content/content-copy';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import VisibilityIcon from 'material-ui/svg-icons/action/visibility';

import OverlayMenuItemConfig from "diy/overlay/interfaces/OverlayMenuItemConfig";

export interface ModuleOverlayStateProps {
    status: OverlayStatus;
    moduleId: number;
    menuOpen: boolean;
    dragging: boolean;
}

export interface ModuleOverlayDispatchProps {
    onHideRequested(payload: {moduleId: number}): any;
    onMenuToggleRequested(payload: {open: boolean}): any;
    onDragStarted(payload: void): any;
    onDragStopped(payload: void): any;
    onClickOutside(): any;
}

export interface ModuleOverlayProps extends React.Props<ModuleOverlay>,
    ModuleOverlayStateProps, ModuleOverlayDispatchProps {
}

export default class ModuleOverlay extends React.Component<ModuleOverlayProps, {}> {
    static ZINDEX = 113;
    private dragEl: HTMLElement;
    private mouseClientX: number;
    private mouseClientY: number;
    private cursor = 'move';
    private spotlight: HTMLElement;

    getModule() {
        return Modul.getInstance(this.props.moduleId);
    }

    getModuleEl(): JQuery {
        if (this.getModule()) {
            return this.getModule().modul;
        }
        return undefined;
    }

    getMenuConfig() {
        let modul = this.getModule();

        let openHandler = () => {
            modul.open();
        };

        let moduleData = modul.getData();

        let section = modul.getParentSection();
        let isInSection = !!section;

        let isToggleableElement = false;
        if (isInSection) {
            if (section.hasToggleableElement(modul.getAlias())) {
                isToggleableElement = true;
            }
        }

        let inSectionMenuItems: OverlayMenuItemConfig[] = [
            {
                isPrimary: true,
                name: "edit",
                primaryText: l10n('moduleOverlay.edit'),
                leftIcon: ModeEditIcon,
                onSelect: openHandler
            }
        ];
        if (isToggleableElement) {
            inSectionMenuItems.push({
                name: "toggleElements",
                primaryText: l10n('section.actionBar.buttons.contentToggles.label'),
                leftIcon: VisibilityIcon,
                onSelect: () => {
                    AppRegistry.getStoreProvider().getStore().dispatch(
                        toggleElementsMenu({visible: true})
                    );
                }
            });
        }

        return {
            moduleId: this.props.moduleId,
            rightOffset: 0,
            defaultAction: openHandler,
            menuItems: isInSection ? inSectionMenuItems : [
                {
                    isPrimary: true,
                    name: "edit",
                    primaryText: l10n('moduleOverlay.edit'),
                    leftIcon: ModeEditIcon,
                    onSelect: openHandler
                },
                {
                    isDivider: true
                },
                {
                    name: "moveup",
                    primaryText: l10n('moduleOverlay.moveup'),
                    leftIcon: KeyboardArrowUpIcon,
                    onSelect: () => {
                        modul.onToolUp();
                        this.hide(this.props.moduleId);
                    },
                    disabled: !modul.getPrevModul().length || !moduleData.supports.moduleMove
                },
                {
                    name: "movedown",
                    primaryText: l10n('moduleOverlay.movedown'),
                    leftIcon: KeyboardArrowDownIcon,
                    onSelect: () => {
                        modul.onToolDown();
                        this.hide(this.props.moduleId);
                    },
                    disabled: !modul.getNextModul().length || !moduleData.supports.moduleMove
                },
                {
                    name: "duplicate",
                    primaryText: l10n('moduleOverlay.duplicate'),
                    leftIcon: ContentCopyIcon,
                    onSelect: () => {
                        modul.onDuplicate();
                        this.hide(this.props.moduleId);
                    },
                    disabled: !moduleData.supports.moduleDuplicate
                },
                {
                    isDivider: true
                },
                {
                    name: "delete",
                    primaryText: l10n('moduleOverlay.delete'),
                    leftIcon: DeleteIcon,
                    onSelect: () => {
                        modul.deleteAction();
                        this.hide(this.props.moduleId);
                    },
                    disabled: !moduleData.supports.moduleDelete
                }
            ] as OverlayMenuItemConfig[]
        };
    }

    render() {
        if (
            this.props.moduleId
            && (
                    this.props.status !== OverlayStatus.ACTIVE
                    ||
                    (
                        this.props.status === OverlayStatus.ACTIVE
                        && this.getModule().getModuleType() !== "matrix"
                    )
            )
        ) {
            return (
                <SyncPosition element={this.getModuleEl()[0]} key="overlaySync">
                    {
                        (box: PositionBox) => {
                            if (this.props.status !== OverlayStatus.ACTIVE) {
                                return this.renderOverlay(box);
                            } else {
                                return this.renderSpotlight(box);
                            }
                        }
                    }
                </SyncPosition>
            );
        } else {
            return null;
        }
    }

    renderOverlay(box: PositionBox) {
        return (
            <OpacityAnimation duration={0.1} key="overlayAnimation">
                <SyncPosition element={document.getElementById('cc-sa')}>
                {
                    (saBox: PositionBox) => {
                        let overlapHorizontal = box.right - saBox.right;
                        let overlapVertical = saBox.top + saBox.height - box.top;
                        let overlayMenuOffset = 0;
                        if (overlapHorizontal < saBox.width && overlapVertical > 0) {
                            overlayMenuOffset = saBox.width - overlapHorizontal;
                        }
                        let menuConfig = this.getMenuConfig();
                        menuConfig.rightOffset = overlayMenuOffset;

                        return (<Overlay
                            key={this.props.moduleId}
                            onMouseLeave={this.onMouseLeave}
                            width={box.width}
                            height={box.height}
                            left={box.left}
                            top={box.top}
                            zIndex={ModuleOverlay.ZINDEX}
                            overlayMenuConfig={menuConfig}
                            status={this.props.status}
                            ref={this.registerOverlayRef}
                            menuOpen={this.props.menuOpen}
                            onMenuToggleRequest={this.onMenuToggleRequest}
                            cursor={this.cursor}
                            touchMode={diy.editor.uiPreference.isPointerModeTouch()}
                            menuText={this.getModule().getParentSection() === null
                                ? l10n("moduleOverlay.menuText")
                                : l10n("moduleOverlay.sectionMenuText")}
                        />);
                    }
                }
                </SyncPosition>
            </OpacityAnimation>
        );
    }

    renderSpotlight(box: PositionBox) {
        let spotlightBottom: string;
        if (this.spotlight) {
            // back up the bottom offset
            spotlightBottom = this.spotlight.style.bottom;
            // make the spotlight not contribute to the total height
            // needed before calling getDocHeight
            this.spotlight.style.bottom = '0px';
        }

        const docHeight = this.getDocHeight();
        const delta = Math.round(document.documentElement.getBoundingClientRect().height - docHeight);

        if (this.spotlight) {
            // restore the spotlight bottom offset after we got the doc height
            this.spotlight.style.bottom = spotlightBottom;
        }

        const maskBox = {
            top: 0,
            left: 0,
            bottom: delta > 0 ? 0 : delta,
            right: 0,
            width: document.body.scrollWidth,
            height: docHeight
        };
        const actionBarEl = document.getElementById(MODULE_ACTION_BAR_ELEMENT_ID);
        const isInSection = !!this.getModule().getParentSection();
        const topBarEl = document.getElementById("diyToolbar");
        const siteAdminEl = document.getElementById("cc-sa");
        const maskExtra = (box: PositionBox) => {
            const boxStyle = {
                position: "fixed",
                width: box.width,
                height: box.height,
                left: box.left,
                top: box.top,
                zIndex: 102000,
                background: "rgba(0,0,0,0.3)",
                cursor: 'pointer'
            };
            return (
                <div onTouchTap={() => {this.getModule().onClickOutside();}} style={boxStyle} />
            );
        };

        return (
            <div>
                <OpacityAnimation duration={0.4} key="spotlightAnimation">
                    <Spotlight
                        ref={(spotlight: Spotlight) => {
                            this.spotlight = ReactDOM.findDOMNode(spotlight) as HTMLElement;
                        }}
                        onTouchTap={() => {this.getModule().onClickOutside();}}
                        maskBox={maskBox}
                        highlightBox={box}
                        zIndex={ModuleOverlay.ZINDEX}
                        showBorder={this.getModule().hasActionBar && this.getModule().hasSpotlightBorder}
                    />
                </OpacityAnimation>
                {
                    /* This is temporary solution for modules not migrated to action-bar that puts a mask
                     over the action-bar of the section for auto-saving the module. This should be removed
                     after all modules in sections are migrated to the action-bar.  */
                    (!this.getModule().hasActionBar && actionBarEl && isInSection) ?
                        <OpacityAnimation duration={0.4} key="actionBarMaskAnimation">
                            <SyncPosition element={actionBarEl}>
                                {
                                    (box: PositionBox) => {
                                        const boxStyle = {
                                            position: "absolute",
                                            width: box.width,
                                            height: box.height,
                                            left: box.left,
                                            top: box.top,
                                            zIndex: 102000,
                                            background: "rgba(0,0,0,0.3)",
                                            cursor: 'pointer'

                                            };
                                        return (
                                        <div onTouchTap={() => {this.getModule().onClickOutside();}} style={boxStyle} />
                                            );
                                        }
                                    }
                            </SyncPosition>
                        </OpacityAnimation>
                        :
                        null
                }
                {
                   /* bugfix DHDIY-33507 modules not migrated to action-bar
                   must have autosave mask over topBar & siteAdmin */
                    (!this.getModule().hasActionBar && topBarEl && !isInSection) ?
                    <OpacityAnimation duration={0.4} key="topBarMaskAnimation">
                        <SyncPosition element={topBarEl} position="fixed">
                        {
                            maskExtra
                        }
                        </SyncPosition>
                    </OpacityAnimation>
                    :
                    null
                }
                {
                    (!this.getModule().hasActionBar && siteAdminEl && !isInSection) ?
                    <OpacityAnimation duration={0.4} key="siteAdminMaskAnimation">
                        <SyncPosition element={siteAdminEl} position="fixed">
                        {
                            maskExtra
                        }
                        </SyncPosition>
                    </OpacityAnimation>
                    :
                    null
                }
            </div>
        );
    }

    componentDidMount() {
        jquery(document).on('diy-editor-module-rerendered.moduleOverlayReact',
            (e: JQueryEventObject, module: Modul) => {
                if (module.moduleId === this.props.moduleId) {
                    this.forceUpdate();
                }
            }
        );
    }

    componentWillUnmount() {
        this.removeListeners();
        jquery(document).off('.moduleOverlayReact');
    }

    componentWillReceiveProps(nextProps: ModuleOverlayProps) {
        if (nextProps.moduleId !== this.props.moduleId) {
            this.removeListeners();
        }
    }

    private registerOverlayRef = (overlay: Overlay) => {
        const overlayEl = ReactDOM.findDOMNode(overlay) as HTMLElement;
        if (overlayEl) {
            this.dragEl = overlayEl;
            let ddm = AppRegistry.getModuleDragDrop();
            if (this.supportsDragging()) {
                this.dragEl.setAttribute('data-moduleid', this.props.moduleId + '');
                ddm.addDragSourceEl(jquery(this.dragEl));
                jquery(this.dragEl)
                    .on('ddstart', this.onDragStarted)
                    .on('ddstop', this.onDragStopped);
                this.cursor = 'move';
            } else {
                this.cursor = 'pointer';
            }
        }
    };

    private onDragStarted = () => {
        this.props.onDragStarted(void 0);
    };

    private onDragStopped = () => {
        this.props.onDragStopped(void 0);
    };

    private onMouseLeave = () => {
        if (!this.props.menuOpen) {
            this.hide(this.props.moduleId);
        }
    };

    private onMenuToggleRequest = (open: boolean) => {
        this.props.onMenuToggleRequested({open});
        if (open) {
            document.body.addEventListener('mousemove', this.syncMouse);
        } else {
            const moduleRect = this.getModuleEl()[0].getBoundingClientRect();
            if (
                this.mouseClientX > moduleRect.left && this.mouseClientX < moduleRect.left + moduleRect.width
                && this.mouseClientY > moduleRect.top && this.mouseClientY < moduleRect.top + moduleRect.height
            ) {
                // do nothing;
            } else {
                this.onMouseLeave();
            }
            document.body.removeEventListener('mousemove', this.syncMouse);
        }
    };

    private syncMouse = (e: MouseEvent) => {
        this.mouseClientX = e.clientX;
        this.mouseClientY = e.clientY;
    };

    private supportsDragging() {
        /* don't allow modules inside matrix modules to be draggable */
        return !(this.getModule().getMatrix() && !this.getModule().getMatrix().supportsDragging());
    }

    private removeListeners() {
        if (this.props.moduleId) {
            jquery(this.dragEl)
                .off('ddstart', this.onDragStarted)
                .off('ddstop', this.onDragStopped);

            let ddm = AppRegistry.getModuleDragDrop();
            ddm.removeDragSources((dragSource: any) => {
                return dragSource.moduleId === this.props.moduleId;
            });
        }
    }

    private hide(moduleId: number) {
        this.props.onHideRequested({moduleId});
    }

    private getDocHeight() {
        const html = document.documentElement;
        const body = document.body;
        return Math.max(
            body.scrollHeight, html.scrollHeight,
            body.offsetHeight, html.offsetHeight,
            body.clientHeight, html.clientHeight
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/ModuleOverlay.tsx
 **/